import React from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import Table from "common/components/Table/Table.jsx";
import Button from "common/components/CustomButtons/Button.jsx";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";

// @material-ui/core components
import LocalHospital from "@material-ui/icons/LocalHospital";
import Close from "@material-ui/icons/Close";
import CheckBox from "@material-ui/icons/CheckBox";
import Edit from "@material-ui/icons/Edit";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import loadContent from "core-module/hoc/loadContent";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  ...regularFormsStyle,
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  stats: importedStyle.stats,
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  actionButton: {
    margin: "0 0 0 5px",
    padding: "5px",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      marginRight: "0px"
    }
  },
  buttonIcon: {
    verticalAlign: "middle",
    width: "17px",
    height: "17px",
    top: "-1px",
    position: "relative"
  },
  right: {
    textAlign: "right"
  },
  addAddress: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "15px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const EmergencyProfilesSummaryCard = props => {
  const { classes } = props;

  const dnColumn = (oGet, id) => {
    if (props.emergencyProfileType === "packageoriented") {
      return (
        <FormControlLabel
          control={
            <Radio
              checked={oGet("selected", "value")}
              onChange={() => props.selectEmergencyProfile(id)}
              value={id}
              name={"radioButton" + id}
              aria-label={id}
              icon={<FiberManualRecord className={classes.radioUnchecked} />}
              checkedIcon={
                <FiberManualRecord className={classes.radioChecked} />
              }
              classes={{
                checked: classes.radio,
                root: classes.radioRoot
              }}
            />
          }
          classes={{
            label: classes.label
          }}
        />
      );
    } else {
      if (Array.isArray(oGet("directorynumbers"))) {
        return oGet("directorynumbers").join(", ");
      } else {
        return null;
      }
    }
  };

  const showDelete = oGet => {
    if (props.emergencyProfileType === "packageoriented") {
      return !oGet("selected", "value");
    } else {
      if (Array.isArray(oGet("directorynumbers"))) {
        return oGet("directorynumbers").length === 0;
      } else {
        return false;
      }
    }
  };

  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <LocalHospital />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          911 - Emergency Address Profiles
        </h4>
      </CardHeader>
      <CardBody>
        <Table
          tableHead={[
            "Address",
            props.emergencyProfileType === "packageoriented"
              ? "Selected"
              : "Phone Numbers",
            "Actions"
          ]}
          tableData={props.getList((oGet, id) => {
            return [
              oGet("addressline"),
              dnColumn(oGet, id),
              <div className={classes.actionButtons}>
                {props.emergencyProfileType === "packageoriented" ? null : (
                  <Button
                    key={"dnButton" + id}
                    color={"primary"}
                    simple
                    className={classes.actionButton}
                    onClick={() =>
                      props.selectDnWizard(id, oGet("directorynumbers"))
                    }
                  >
                    <CheckBox className={classes.buttonIcon} />
                  </Button>
                )}
                <Button
                  color={"success"}
                  simple
                  className={classes.actionButton}
                  onClick={() => props.onClickEdit(id)}
                >
                  <Edit className={classes.buttonIcon} />
                </Button>
                {showDelete(oGet) ? (
                  <Button
                    key={"deleteButton" + id}
                    color={"danger"}
                    simple
                    className={classes.actionButton}
                    onClick={() => props.onClickDelete(id)}
                  >
                    <Close className={classes.buttonIcon} />
                  </Button>
                ) : null}
              </div>
            ];
          })}
          customHeadCellClasses={[classes.right]}
          customHeadClassesForCells={[2]}
        />
        <div className={classes.addAddress}>
          <Button onClick={() => props.onClickEdit(0)} color="primary">
            Add New Address
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(
  loadContent(
    "user.session/billingpackage.props/emergencyprofile_summary",
    EmergencyProfilesSummaryCard
  )
);
